/*
 * @Author: your name
 * @Date: 2020-08-17 11:19:55
 * @LastEditTime: 2020-08-26 16:13:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/api/common.js
 */
import { axiosRequest } from '@/util/axios-request';
export var apiUpload = function apiUpload(data) {
  return axiosRequest({
    // url: '/sys/tool/upload_url',
    url: '/app/tool/upload_url',
    data: data
  });
};

// 获取图片验证码
export var getImgCode = function getImgCode(data) {
  return axiosRequest({
    url: '/auth/sms/captcha',
    errorMessage: true,
    data: data
  });
};
// 获取短信验证码
export var getShortCode = function getShortCode(data) {
  return axiosRequest({
    url: '/auth/sms/send',
    errorMessage: true,
    data: data
  });
};
// 获取部门列表
export var getDepartmentList = function getDepartmentList(data) {
  return axiosRequest({
    url: '/web/Organization/departmentList',
    data: data
  });
};
// 获取公司信息
export var getCompanyInfo = function getCompanyInfo(data) {
  return axiosRequest({
    url: '/web/company/info',
    method: 'get',
    params: data
  });
};
// 通用部门列表
export var getCommonDepList = function getCommonDepList(params) {
  return axiosRequest({
    url: '/web/Organization/commonDeptList',
    params: params
  });
};
// 人员查询（通用插件使用）
export var getCommonDepStaff = function getCommonDepStaff(params) {
  return axiosRequest({
    url: '/web/Organization/commonSearchDeptStaff',
    params: params
  });
};
export var uploadFn = function uploadFn(url, data) {
  return axiosRequest({
    url: url,
    data: data
  });
};
export var currentSession = function currentSession(url) {
  return axiosRequest({
    url: '/auth/user/currentSession'
  });
};

/**
 * 根据员工ID组查询一组员工信息 用于员工选择组件
 * @param { Array } params 员工id数组
 * @returns
 */
export var getStaffInfoByUserids = function getStaffInfoByUserids(data) {
  return axiosRequest({
    url: '/web/staff/getStaffInfoByUserids',
    data: data
  });
};